import React from 'react';
import ReactSVG from 'react-svg';

import DeskNav from '../layouts/DeskNav';

import '../../styles/home.scss'; 
import NameImageWhite from '../../images/AlejandroAlfaro-blanco.svg';
import MainImage from '../../images/alejandro-1-WEB-cuadrada.jpg';
import AImageWhite from '../../images/A-blanco.svg';

export default (props) => {
	return (
		<main className='home'>	
			<div className='home-info'>
				<img className='main-image' src={MainImage} />
				<AImageWhite className='intro-middle-svg' />
				<div>
					<NameImageWhite className='name-svg' />
					<div className='degree-name'>
						<p>{props.degree.line1}</p>
						<p>{props.degree.line2}</p>
						<p>{props.degree.line3}</p>
						<p> 
							{props.degree.uni}
							({props.degree.graduated})
						</p>
					</div>
					
				</div>
			</div>
			<DeskNav />	
		</main>
	)
}